module.exports = __webpack_public_path__ + "img/Group.7cdfb84b.jpg";